`use client`;

import {
  ClientOnly,
  IconButton,
  IconButtonProps,
  Skeleton,
} from "@chakra-ui/react";
import * as React from "react";
import { LuSun } from "react-icons/lu";

export interface ColorModeProviderProps {
  children?: React.ReactNode;
  /** Kept for call-site compatibility; app is light-only. */
  defaultTheme?: string;
  [key: string]: unknown;
}

/**
 * Light-only provider. Avoids next-themes ThemeProvider, which injects a
 * <script> that React 19 / Next.js 16+ logs as a client render error.
 */
export function ColorModeProvider({ children }: ColorModeProviderProps) {
  return <>{children}</>;
}

export function useColorMode() {
  return {
    colorMode: "light" as const,
    setColorMode: (_theme: string) => {},
    toggleColorMode: () => {},
  };
}

export function useColorModeValue<T>(light: T, _dark: T) {
  return light;
}

export function ColorModeIcon() {
  return <LuSun />;
}

interface ColorModeButtonProps extends Omit<IconButtonProps, "aria-label"> {}

export const ColorModeButton = React.forwardRef<
  HTMLButtonElement,
  ColorModeButtonProps
>(function ColorModeButton(props, ref) {
  const { toggleColorMode } = useColorMode();
  return (
    <ClientOnly fallback={<Skeleton boxSize="8" />}>
      <IconButton
        onClick={toggleColorMode}
        variant="ghost"
        aria-label="Toggle color mode"
        size="sm"
        ref={ref}
        {...props}
        css={{
          _icon: {
            width: "5",
            height: "5",
          },
        }}
      >
        <ColorModeIcon />
      </IconButton>
    </ClientOnly>
  );
});
